import React, {Fragment, useEffect, useState} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFile,faDownload } from '@fortawesome/free-solid-svg-icons';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {Form,Button,Spinner,} from 'react-bootstrap';
import axios from 'axios';
import './recrutement.css';
import Recepisse from '../../components/RecepisseDepot/index'
import Input, { InputCheckbox } from '../../components/Input';
import InputT from '../../components/Input';
import { InputF } from '../../components/Input';
import { InputOption, InputRadio,InputCheckB } from '../../components/Input';
import Alert, { Alert2 } from '../../components/Alerte';
import Update from '../Update/index';
import { libelleEts, domaines, postesPer, type_postes, postesPats, etabsPATS } from './config';
import { use } from 'react';
import Env from '../../hooks/Env';
import useDocumentTitle from '../../hooks/useDocumentTitle';

const renderTooltip = (props) => (
    <Tooltip id="button-tooltip"  {...props}>
      Ajouter un nouveau fichier
    </Tooltip>
  );
  const IconForFile = (props) => {
    return (
        <>
        <OverlayTrigger
            placement="right"
            delay={{ show: 100, hide: 400 }}
            overlay={renderTooltip}
            >
                <Button  variant="primary" className='btn btn-primary' size="sm" onClick={() => {props.toggleInputVisibility(props.name)}}><FontAwesomeIcon icon={faDownload} /> {props.label} {props.type}</Button>
            {/* <FontAwesomeIcon onClick={() => {props.toggleInputVisibility(props.name)}} icon={faFile} className='btn btn-primary mr-2' /> */}
        </OverlayTrigger>
        </>
    )
  }
const RecrutementPer = ({props}) => {
    useDocumentTitle('Recrutement PATS');
    const API_URL = Env().API_URL ;
    const [InputVisible, SetInputVisible] = useState({
        'communication5':false,
        'justificatif':false,
        'diplome':false,
        'publication2':false,
        'publication3':false,
        'publication4':false,
        'publication5':false,
        'publication6':false,
        'publication7':false,
        'publication8':false,
        'publication9':false,
        'publication10':false,
        'communication2':false,
        'communication3':false,
        'communication4':false,
        'justificatif2':false,
        'justificatif1':false,
        'justificatif3':false,
        'justificatif4':false,
        'justificatif5':false,
        'justificatif6':false,
        'justificatif7':false,
        'justificatif8':false,
        'diplome2':false,
        'diplome3':false,
        'diplome4':false,
        'diplome5':false,
        'diplome6':false,
    })
    const toggleInputVisibility = (state) => {
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
    }
    
    const removeFile = (fieldName,state) => {
        // console.log("Au moment ",selectedFiles.publication7)
        const updatedInputVisible = { ...InputVisible };
        updatedInputVisible[state] = !updatedInputVisible[state];
        SetInputVisible(updatedInputVisible);
        // Créez une copie de l'état actuel
        const updatedFiles = { ...selectedFiles };
      
        // Supprimez l'élément spécifique
        updatedFiles[fieldName] = null;
      
        // Mettez à jour l'état avec la nouvelle copie
        setSelectedFiles(updatedFiles);
        // console.log("Aprés mise à jour ",selectedFiles.publication7)
      };
    const [dataForm, setDataForm] = useState('');
    const [nationalities, setNationalities] = useState([]);
    const [step, setStep] = useState(1);
    const [update,setUpdate] = useState(false);
    const [selectedPostes, setSelectedPostes] = useState([]) // Pour gérer les postes sélectionnés
    const [etablissementCounter, setEtablissementCounter] = useState(0); // Compteur global pour les établissements
    const [selectedEtabPats, setSelectedEtabPats] = useState([]); // Etablissements cochés pour PATS
    const [valid, SetIsValid] = useState({
        isValidPhoneNumber: false,
      });
    const[ messageAlerte, setMessageAlerte] = useState('')
    const [errors, setErrors] = useState(false);
    const [depotsuccess, setDeppotSuccess] = useState(false);
    const [depotsuccess2, setDeppotSuccess2] = useState(false);
    const maxFileSize = 1024 * 1024 * 2; //1Mo
    const [show, setShow] = useState(false);
    const [complete, setComplete] = useState(false);
    const [campagne, setCampagne] = useState(false);
    const handleClose = () => setShow(false);
    const [selectedFiles, setSelectedFiles] = useState({
        "cv":true,
        "copie_carte_id" : true,
        "demande" : true,
        "lettre_motivation" : true,
        "copie_diplome" : true,
        "recommandation1" : true,
        "recommandation2" : true,
        "resume_these" : true,
        "publication_scientifique" : true,
        "attestation_travail" : true,
        "justificatif1" : true,
        "justificatif2" : true,
        "justificatif3" : true,
        "justificatif4" : true,
        "justificatif5" : true,
        "justificatif6" : true,
        "communication" : true,
        "diplome2" : true,
        "diplome3" : true,
        "diplome4" : true,
        "diplome5" : true,
        "diplome6" : true,
        "justificatif7" : true,
        "justificatif8" : true,
        "communication2" : true,
        "communication3" : true,
        "communication4" : true,
        "communication5" : true,
        "publication2" : true,
        "publication3" : true,
        "publication4" : true,
        "publication5" : true,
        "publication6" : true,
        "publication7" : true,
        "publication8" : true,
        "publication9" : true,
        "justificatif_enseignement" : true,
    });
    const [gestionfichier, setGestionFichier] = useState({
        "cv":false,
        "copie_carte_id" : false,
        "demande" : false,
        "lettre_motivation" : false,
        "copie_diplome" : false,
        "recommandation1" : false,
        "recommandation2" : false,
        "resume_these" : false,
        "publication_scientifique" : false,
        "attestation_travail" : false,
        "justificatif1" : false,
        "justificatif2" : false,
        "justificatif3" : false,
        "justificatif4" : false,
        "justificatif5" : false,
        "justificatif6" : false,
        "communication" : false,
        "diplome2" : false,
        "diplome3" : false,
        "diplome4" : false,
        "diplome5" : false,
        "diplome6" : false,
        "justificatif7" : false,
        "justificatif8" : false,
        "communication2" : false,
        "communication3" : false,
        "communication4" : false,
        "communication5" : false,
        "publication2" : false,
        "publication3" : false,
        "publication4" : false,
        "publication5" : false,
        "publication6" : false,
        "publication7" : false,
        "publication8" : false,
        "publication9" : false,
        "justificatif_enseignement" : false,
    });
    const [submitted, setSubmitted] = useState(false);
    const [data, setData] = useState();  /*données d'un user avec dépot réussie */
    const handleFileChange = (event, key) => {
        const file = event.target.files[0];
        const elements = document.getElementsByName(key)
        if (file?.size < maxFileSize){
            if (file?.type === "application/pdf") {
                setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: file
                }));
                setGestionFichier((prevSelectedFiles) => ({
                    ...prevSelectedFiles,
                    [key]: true
                }));
                for (var i = 0; i < elements.length; i++) {
                    var element1 = elements[i];
                    element1.style.border = ""; 
                
                }
            } else {
            //     setSelectedFiles((prevSelectedFiles) => ({
            //     ...prevSelectedFiles,
            //     [key]: false
            // }));
            // setGestionFichier((prevSelectedFiles) => ({
            //     ...prevSelectedFiles,
            //     [key]: false
            // }));
            alert("Veuillez télécharger un fichier au format PDF.");
            event.target.value = '';
            return ;
            }
            
        } else {
            setSelectedFiles((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            setGestionFichier((prevSelectedFiles) => ({
                ...prevSelectedFiles,
                [key]: false
            }));
            for (var j = 0; j < elements.length; j++) {
                var element = elements[j];
                element.style.border = "2px solid #BC0C0C";
                element.style.transition ='border 0.5s ease-in-out;' 
              
            }

        }
    };
    function handleChange (e) {
        const name= e.target.name;
        let value = e.target.value;
        let type = e.target.type;
        const checked = e.target.checked;
        
        // if (name === 'telephone' ) {
        //     const phoneRegex = /^\d{9}$/;  //validation numéro de téléphone
        //     SetIsValid((valid) => ({
        //         ...valid,
        //         isValidPhoneNumber: phoneRegex.test(value),
        //     }));
        // }
        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            SetIsValid((valid) => ({
                ...valid,
                isValidEmail: emailRegex.test(value),
            }));
        }
        setDataForm({ ...dataForm, [name]: value });
        // reset PATS établissement selection when poste changes
        if (name === 'poste') {
            setSelectedEtabPats([]);
        }
    }

    // Gestion des établissements pour PATS
    const handleEtabPatsChange = (etsCode, checked) => {
        setSelectedEtabPats(prev => checked ? [...prev, etsCode] : prev.filter(c => c !== etsCode));
        console.log("Etablissements PATS sélectionnés :", selectedEtabPats);
    };
    
    // Fonction pour gérer la sélection d'établissements (plusieurs par poste)
    const handleEtablissementChange = (posteIndex, etsCode, checked) => {
        setDataForm(prevData => {
            const newData = { ...prevData };
            
            // Récupérer tous les établissements actuels pour ce poste
            const currentEtablissements = {};
            let maxEtaIndex = 0;
            
            // Scanner tous les champs etablissement{i} qui appartiennent à ce poste
            Object.keys(newData).forEach(key => {
                if (key.startsWith('etablissement') && key.match(/\d+/)) {
                    const etaNum = parseInt(key.match(/\d+/)[0]);
                    // Vérifier si cet établissement appartient à ce poste
                    if (newData[`poste_eta_${key}`] === posteIndex) {
                        currentEtablissements[key] = newData[key];
                        maxEtaIndex = Math.max(maxEtaIndex, etaNum);
                    }
                }
            });
            
            if (checked) {
                // Ajouter un nouvel établissement
                const newEtaIndex = etablissementCounter + 1;
                setEtablissementCounter(newEtaIndex);
                newData[`etablissement${newEtaIndex}`] = etsCode;
                newData[`poste_eta_etablissement${newEtaIndex}`] = posteIndex; // Lien avec le poste
            } else {
                // Retirer l'établissement
                Object.keys(currentEtablissements).forEach(key => {
                    if (newData[key] === etsCode) {
                        delete newData[key];
                        delete newData[`poste_eta_${key}`];
                    }
                });
                setEtablissementCounter(etablissementCounter - 1);
            }
            
            return newData;
        });
    };
    
    // Fonction pour vérifier si un établissement est sélectionné pour un poste
    const isEtablissementSelected = (posteIndex, etsCode) => {
        return Object.keys(dataForm).some(key => {
            if (key.startsWith('etablissement') && dataForm[key] === etsCode) {
                return dataForm[`poste_eta_${key}`] === posteIndex;
            }
            return false;
        });
    };
    
    // Fonction pour gérer la sélection/désélection d'un poste
    const handlePosteSelection = (poste, checked) => {
        if (checked) {
            // Ajouter le poste à la liste
            const newIndex = selectedPostes.length + 1;
            setSelectedPostes([...selectedPostes, { poste, index: newIndex }]);
            setDataForm(prevData => ({
                ...prevData,
                [`poste${newIndex}`]: poste
            }));
        } else {
            // Retirer le poste et tous ses établissements associés
            const updatedPostes = selectedPostes.filter(p => p.poste !== poste);
            const newDataForm = { ...dataForm };
            const posteToRemove = selectedPostes.find(p => p.poste === poste);
            
            if (posteToRemove) {
                // Supprimer le poste
                delete newDataForm[`poste${posteToRemove.index}`];
                
                // Supprimer tous les établissements liés à ce poste
                Object.keys(newDataForm).forEach(key => {
                    if (key.startsWith('etablissement') || key.startsWith('poste_eta_')) {
                        if (newDataForm[`poste_eta_${key}`] === posteToRemove.index || 
                            newDataForm[key] === posteToRemove.index) {
                            delete newDataForm[key];
                        }
                    }
                });
            }
            
            // Réorganiser les postes avec de nouveaux index
            updatedPostes.forEach((p, idx) => {
                const newIdx = idx + 1;
                const oldIdx = p.index;
                
                if (oldIdx !== newIdx) {
                    // Renommer le poste
                    newDataForm[`poste${newIdx}`] = newDataForm[`poste${oldIdx}`];
                    delete newDataForm[`poste${oldIdx}`];
                    
                    // Mettre à jour les références dans poste_eta_
                    Object.keys(newDataForm).forEach(key => {
                        if (key.startsWith('poste_eta_') && newDataForm[key] === oldIdx) {
                            newDataForm[key] = newIdx;
                        }
                    });
                    
                    p.index = newIdx;
                }
            });
            
            setSelectedPostes(updatedPostes);
            setDataForm(newDataForm);
        }
    };
    
    // Fonction pour obtenir l'index d'un poste sélectionné
    const getPosteIndex = (poste) => {
        const found = selectedPostes.find(p => p.poste === poste);
        return found ? found.index : null;
    };
    const handleNextStep = () => {
        if (step === 1) {
           if (!dataForm.email || !dataForm.civilite || !dataForm.prenom|| !dataForm.nom || !dataForm.date_naissance || !dataForm.lieu_naissance || !dataForm.telephone || !dataForm.address) {
                setErrors(true)
           } 
           else {
                setErrors(false)
                setStep(step + 1)
           }
            
        } else if (step === 2) {
            // setStep(step + 1);
            // return
            if (dataForm.type_poste === 'PER') {
                console.log(dataForm.type_poste, dataForm.poste1, dataForm.etablissement1, dataForm.ecole_postulee, dataForm.annee_experience, dataForm.diplome)
                if (dataForm.type_poste && dataForm.poste1 && dataForm.etablissement1 && dataForm.ecole_postulee && dataForm.annee_experience && dataForm.diplome) {
                    setErrors(false);
                    setStep(step + 1);
                   } else {
                        setErrors(true);
                }   
            } else if (dataForm.type_poste === 'PATS') {
                // console.log(selectedEtabPats.length)
                // console.log(dataForm.type_poste, dataForm.poste, dataForm.etablissement1, dataForm.diplome)
                if (dataForm.type_poste && dataForm.poste  && dataForm.diplome && selectedEtabPats.length > 0) {
                    setErrors(false);
                    setStep(step + 1);
                   } else {
                        setErrors(true);
                }   
            }
             else {
                if (dataForm.type_poste && dataForm.pays && dataForm.poste1 && dataForm.etablissement1 && dataForm.diplome) {
                    setErrors(false);
                    setStep(step + 1);
                } else {
                    setErrors(true);
                }
            }
            
        }
    };
  
    const handlePreviousStep = () => {
      setStep(step - 1);
    };
    const handleSubmit = async (e) => {
        try {
            e.preventDefault();
            const formData = new FormData();
            const nameFiles = ["cv","copie_carte_id","demande","lettre_motivation","copie_diplome","communication","recommandation1","recommandation2","resume_these",
            "publication_scientifique","attestation_travail","justificatif1","justificatif2","justificatif3","justificatif4","justificatif5","justificatif6",
            "diplome2","diplome3","diplome4","diplome5","diplome6","justificatif7","justificatif8","communication2","communication3","communication4",
            "communication5","publication2","publication3","publication4","publication5","publication6","publication7","publication8","publication9","justificatif_enseignement"]
            for (const i in nameFiles) {
                if (selectedFiles[nameFiles[i]]) {
                    if ((selectedFiles[nameFiles[i]]).size <= maxFileSize) {
                        formData.append(nameFiles[i] , selectedFiles[nameFiles[i]])
                    } else {
                        // console.log("fichier trop gros");
                    }
                }
            }
            for (let key in dataForm) {
                // console.log(dataForm[key])
                if (dataForm.hasOwnProperty(key)) {
                      // Exclure les champs poste_eta_ qui sont utilisés uniquement en interne
                      if (key.startsWith('poste_eta_')) {
                          continue;
                      }
                      
                      if( dataForm[key] !== null) {
                        if (key === 'pays') {
                            if (dataForm['type_poste'] === 'PATS') {
                                if (dataForm['pays'] !== 'senegal') {
                                    dataForm['pays'] = 'SENEGAL'
                                }
                            }
                        }
                        formData.append(key ,dataForm[key])
                      }
              }
            }
                        // Ajouter les établissements sélectionnés pour PATS
                        if (dataForm.type_poste === 'PATS' && selectedEtabPats.length > 0) {
                                selectedEtabPats.forEach((code, idx) => {
                                        formData.append(`etablissement${idx + 1}`, code);
                                });
                        }
            var showALerte = nameFiles.some(field => selectedFiles[field] === false);
         for (let pair of formData.entries()) {
                // console.log(pair[0] + ':' + pair[1]);
              }
            if (showALerte) {
                 setShow(true);
                //  setOk(false)
            }
            else {
                setComplete(true)
                setSubmitted(true);
                // console.log("Requete en cours d'envoi ...")
                const response = await axios.post(
                    `${API_URL}/recrutement/`,
                    formData,
            {
                    headers: {
                    'Content-Type': 'multipart/form-data',
                    },
                    });
            
            if (response.status === 200) {
                if (response.data.detail) {
                    setSubmitted(false);
                    
                    setDeppotSuccess2(true)
                } else {
                    setSubmitted(false);
                   
                    const dataPersonDepot = response?.data?.data;
                    setData(dataPersonDepot);
                    setDeppotSuccess(true);
                }
            } else {
                // console.error('Error uploading files');
                // console.log("Détail de la réponse ",response.status)
            }
        }
    } catch (error) {
        setSubmitted(false);
        if (error.response && error.response.status === 404) {
            setCampagne(true);
            setMessageAlerte("Certains fichiers dépassent la taille maximale autorisée de 2 Mo. Veuillez vérifier et réessayer.");
        }
    //    console.error('Error', error);
    }
};
    const calculateProgress = () => {
        return (step / 3) * 100; // Supposons que vous ayez 3 étapes au total
      };
    function handleUpdate () {
        update ? setUpdate(false) : setUpdate(true)
        
    }
    useEffect(() => {
    //    console.log(dataForm)
    }, [dataForm]);
  return (
    <>
    <Alert show={show} handleClose={handleClose} />
    {campagne ? <Alert2 message = 'Cette campagne de recrutement est terminée' /> : null }
    {depotsuccess2 ? <Alert2 message = 'Impossible de postuler, une candidature a deja été enregistrée avec cet email' /> : null }
    {depotsuccess ? <Recepisse  dataPerson={data}/> : null}
    {update ? <Update /> : null}-
      <div className='container mb-2 ' id='mainDepot'>
        {/* {step 1 } */}
        <div className='row'>
            {/* <div className="progress" role="progressbar" aria-label="Animated striped example" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"> */}
            {/* <div className="progress-bar progress-bar-striped progress-bar-animated" style={{ width: `${calculateProgress()}%` }} ></div> */}
            <div className="d-flex justify-content-between align-items-center mt-2" style={{ maxWidth: 500, margin: '0 auto' }}>
                {[1, 2,3].map((num,idx,arr) => (
                    <React.Fragment key={num}>
                <div key={num} className="text-center" style={{ flex: 1 }}>
                    <div
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: '50%',
                        background: (step === num || step > num) ? '#00A7E1' : '#e9ecef',
                        color: (step === num || step > num) ? '#fff' : '#495057',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        margin: '0 auto',
                        fontWeight: 'bold',
                        fontSize: 18,
                        border: step === num || step > num ? '2px solid #00A7E1' : '2px solid #e9ecef',
                        boxShadow: step === num || step > num ? '0 0 8px #00A7E1' : 'none',
                        transition: 'all 0.2s'
                    }}
                    >
                    {num}
                    </div>
                </div>
                    {idx < arr.length - 1 && step > num && (
                        <div style={{ width: 30, height: 2, background: '#0d6efd', margin: '0 2px', alignSelf: 'center' }} />
                        )}
                        {idx < arr.length - 1 && step <= num && (
                        <div style={{ width: 30, height: 2, background: '#e9ecef', margin: '0 2px', alignSelf: 'center' }} />
                        )}
                    </React.Fragment>
                ))}
            </div>
        <div id='nameModule' className=''>
                    <p> {step===1 ? 'Informations personnelles' : null }</p>
                    <p> {step===2 ? 'Informations professionnelles' : null }</p>
                    <p> {step===3 ? 'Documents' : null }</p>
        </div>
            <div id='form' className={`step step-${step}`}>
            <Form onSubmit={handleSubmit}>
            <div>
                {step === 1 && (
                    <div id="step1" className='mb-3'>
                        <Input type='email' focus={true} value={dataForm.email || ''} label="Email" name='email' onChange={handleChange} />
                        <Form.Group>
                            <div className='d-inline'>
                                <Form.Check
                                inline
                                        type="radio"
                                        label="Monsieur"
                                        value='Monsieur'
                                        required
                                        checked = {dataForm.civilite === 'Monsieur'}
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className='d-inline'>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Madame"
                                        value='Madame'
                                        checked = {dataForm.civilite === 'Madame'}
                                        required
                                        name="civilite"
                                        onChange={handleChange}
                                    />
                                </div>
                            </Form.Group>
                            <div className='row' id='test'>
                            <Input className="col-md-6 col-sm-12" value={dataForm.prenom || ''}  type='text' label="Prénom (s)" name='prenom' onChange={handleChange} />
                            <Input className="col-md-6 col-sm-12" value={dataForm.nom || ''} type='text' label="Nom" name='nom' onChange={handleChange}/>
                            </div>
                            <div className='row'>
                                <Input className="col-md-6 col-sm-12" value={dataForm.date_naissance || ''} type='date' label="Date de Naissance" name='date_naissance' onChange={handleChange} />
                                <Input className="col-md-6 col-sm-12" value={dataForm.lieu_naissance || ''} type='text' label="Lieu de naissance" name='lieu_naissance' onChange={handleChange} />
                            </div>
                            <InputT type='number' value={dataForm.telephone || ''} label="Téléphone" name='telephone' onChange={handleChange} />
                            {/* {!valid.isValidPhoneNumber ? <span style={{color:'red'}}>{messageAlerte} </span>: null} */}
                            <Input type='text' value={dataForm.address || ''} label="Adresse" name='address' onChange={handleChange} />
                    </div>
                )}
                {/* terminaison de step 1 */}
                {/* step 2 */}
                {step === 2 && (
                <div className='mb-3'>
                <Form.Group id='serie'>
                    <Form.Label className='fw-medium'>Personnel <span style={{color:'red'}}>*</span></Form.Label>
                    {type_postes.map((type_poste, index) => (
                        <div key={index} className='d-inline me-3'>
                            <InputRadio checked={dataForm.type_poste === type_poste} value={type_poste} label={type_poste} disabled={type_poste !=="PER"} onChange={handleChange} name='type_poste' />
                        </div>
                    ))}
                </Form.Group>
                {dataForm.type_poste === 'PER' && (
                    <Form.Group id=''>
                        <Form.Label className='fw-medium'>Filières<span style={{color:'red'}}>*</span></Form.Label>
                            <Form.Select name='ecole_postulee' required value={dataForm.ecole_postulee} className='mb-2 me-3 d-inline' onChange={handleChange}>
                            <InputOption value="" label="--- Selectionner ---" />
                            {dataForm.type_poste ? <>
                            {domaines.map((domaine, index) => (
                                <InputOption key={index} value={domaine} label={domaine} />
                            ))}
                            </> : null }
                            
                            </Form.Select>
  
                    </Form.Group>
                    )}
                    {dataForm.type_poste === 'PER' && (
                <Form.Group id='ecole'>
                    <Form.Label className='fw-medium'>Spécialité <span style={{color:'red'}}>*</span> </Form.Label>
                    {postesPer[dataForm.ecole_postulee] ? 
                    <>
                        <div className="border rounded p-1" style={{maxHeight: '600px', overflowY: 'auto'}}>
                            {Object.entries(postesPer[dataForm.ecole_postulee]).map(([poste, etablissements], index) => {
                                const posteIndex = getPosteIndex(poste);
                                const isSelected = posteIndex !== null;
                                
                                return (
                                    <div key={index} className="mb-1 pb-2 border-bottom">
                                        <div className="mb-0">
                                            <InputCheckB 
                                                checked={isSelected} 
                                                value={poste} 
                                                label={`${poste}`} 
                                                onChange={(e) => handlePosteSelection(poste, e.target.checked)} 
                                                name={`poste_checkbox_${index}`} 
                                            />
                                            {/* {isSelected && <span className="badge bg-primary ms-2">Poste {posteIndex}</span>} */}
                                        </div>
                                        {isSelected && (
                                            <div className="">
                                                <Form.Label className='fw-medium small'>Établissement(s) pour ce poste <span style={{color:'red'}}>*</span></Form.Label>
                                                <div className=""></div>
                                                {etablissements.map((etsCode, etaIdx) => {
                                                    const isChecked = isEtablissementSelected(posteIndex, etsCode);
                                                    
                                                    return (
                                                        <div key={etaIdx} className="mb-1" style={{borderRadius: "0px 25px 25px 0px",
                                                            boxShadow: "4px 2px 4px 2px rgba(26, 22, 22, 0.1)",
                                                            padding: 2,
                                                            border: "1px solid #99371f25",
                                                            marginLeft: 9}}>
                                                            <InputCheckB 
                                                                checked={isChecked} 
                                                                value={etsCode} 
                                                                label={libelleEts[etsCode]} 
                                                                onChange={(e) => handleEtablissementChange(posteIndex, etsCode, e.target.checked)} 
                                                                name={`eta_check_${posteIndex}_${etaIdx}`} 
                                                            />
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                    </>
                    : <p className="text-muted">Veuillez d'abord sélectionner une filière</p> }
                </Form.Group>
                )}
                {dataForm.type_poste === 'PATS' && (
                <>
                <Form.Group className="mb-3">
                    <Form.Label className='fw-medium'>Poste<span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='poste' required value={dataForm.poste || ''} onChange={handleChange}>
                        <option value="">--- Sélectionner ---</option>
                        {Object.entries(postesPats).map(([poste, etabs], index) => {
                            const etaLabels = (etabs || []).map(code => libelleEts[code] || etabsPATS[code] || code);
                            const etaText = etaLabels.join(' | ');
                            return (
                                <option key={index} value={poste}>{`${poste}`}</option>
                            );
                        })}
                    </Form.Select>
                </Form.Group>
                {dataForm.poste && postesPats[dataForm.poste] && (
                    <Form.Group className="mb-3">
                        <Form.Label className='fw-medium'>Structure(es) pour ce poste (plusieurs choix possibles)</Form.Label>
                        <div className="border rounded p-2" style={{maxHeight: '300px', overflowY: 'auto'}}>
                            {postesPats[dataForm.poste].map((etsCode, idx) => {
                                const label = libelleEts[etsCode] || etabsPATS[etsCode] || etsCode;
                                const checked = selectedEtabPats.includes(etsCode);
                                return (
                                    <div key={idx} className="mb-1" style={{borderRadius: '4px', padding: '6px 8px', border: '1px solid #eee'}}>
                                        <InputCheckB
                                            checked={checked}
                                            value={etsCode}
                                            label={label}
                                            onChange={(e) => handleEtabPatsChange(etsCode, e.target.checked)}
                                            name={`etablissement${idx}`}
                                        />
                                    </div>
                                );
                            })}
                        </div>
                    </Form.Group>
                )}
                </>
                )}
                <Form.Group>
                    <Form.Label className='fw-medium'>Diplôme le plus élevé<span style={{color:'red'}}>*</span></Form.Label>
                    <Form.Select name='diplome' required value={dataForm.diplome} onChange={handleChange}>
                        <option value="">--- Selectionner ---</option>
                        {dataForm.type_poste ? 
                        <>
                            {dataForm.type_poste === 'PER' ?
                            <>
                                <option>Doctorat</option>
                                <option>Doctorat d'état</option>
                                <option>Nouvelle thèse</option>
                                <option>Thèse unique</option>
                                <option>PHD ou equivalent</option>
                                <option>Doctorat 3eme Cycle</option>
                                <option>DEA</option>
                                <option>Master</option>
                                <option>Ingénieur</option>
                            </>
                            :
                            <>
                                <option>Master</option>
                                <option>Ingénieur</option>
                                <option>Maitrise</option>
                                <option>Licence</option>
                                <option>DEUG / DUEL</option>
                                <option>BAC + 2</option>
                                <option>BTS</option>
                                <option>DUT</option> 
                                <option>DTS</option>
                                <option>BAC + 4</option>
                                
                            </>
                        }
                        </>
                        : null }
                    </Form.Select>
                </Form.Group>
                {dataForm.type_poste === 'PER' && (
                <Form.Group id=''>
                <Form.Label className='fw-medium'>{dataForm.type_poste === 'PER' ? 'Grade CAMES' : ''} <span style={{color:'red'}}>*</span></Form.Label>
                <Form.Select name='annee_experience' required value={dataForm.annee_experience} onChange={handleChange}>
                    <option value="" >--- Selectionner ---</option>
                    {dataForm.type_poste === "PER" && (
                        <>
                            <InputOption value="Pas de grade" label="Pas de grade" />
                            <InputOption value="Maître assistant" label="Maître assistant" />
                            <InputOption value="Maître de conférences" label="Maître de conférences" />
                            <InputOption value="Professeur titulaire" label="Professeur titulaire" />
                        </>
                    )}
                </Form.Select>
                </Form.Group>
                )}
                    {/* <Input type='text' label="Nationalité " defaulValue="Sénégalaise"  /> */}
                </div>
                )}
                {/* terminaison de step 2 */}
                {/* step 3 */}
                {step === 3 && (
                <div className='mb-3'>
                <InputF required={true} id="copie_carte" className="rounded-left mb-2" label="Copie légalisée de la carte d'identité nationale ou du passeport " message={<span style={{color:'red'}}>*</span>} type='file' name='copie_carte_id' onChange={(e) => handleFileChange(e,"copie_carte_id")} />
                    {!selectedFiles["copie_carte_id"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="CV daté et signé" type='file' message={<span style={{color:'red'}}>*</span>} name='cv' onChange={(e) => handleFileChange(e,"cv")} />
                    {!selectedFiles["cv"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="Demande manuscrite adréssée au Recteur de l'UAM" message={<span style={{color:'red'}}>*</span>} type='file' name='demande' onChange={(e) => handleFileChange(e,"demande")} />
                    {!selectedFiles["demande"] ? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                    <InputF required={true} className="rounded-left mb-2" label="Lettre de Motivation" message={<span style={{color:'red'}}>*</span>} type='file' name='lettre_motivation' onChange={(e) => handleFileChange(e,"lettre_motivation")} />
                    {!selectedFiles["lettre_motivation"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}  
                    <InputF required={true}  className="rounded-left mb-2" label="Copie légalisée des diplômes" message={<span style={{color:'red'}}>*</span>} type='file' name='copie_diplome' onChange={(e) => handleFileChange(e,"copie_diplome")} />
                    {!selectedFiles["copie_diplome"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null} 
                    {/* <InputF required={true} className="rounded-left mb-2" label="Copie légalisée du diplôme de BAC" message={<span style={{color:'red'}}>*</span>} type='file' name='diplome2' onChange={(e) => handleFileChange(e,"diplome2")} />
                    {!selectedFiles["diplome2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null} */}
                    {gestionfichier["copie_diplome"] && gestionfichier["copie_diplome"]?  
                            <>
                            {!InputVisible.diplome3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un diplome" name='diplome3' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome3' onChange={(e) => handleFileChange(e,"diplome3")} />
                                    {!selectedFiles["diplome3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["diplome3"] ?  
                            <>
                            {!InputVisible.diplome4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un diplome" name='diplome4' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome4' onChange={(e) => handleFileChange(e,"diplome4")} />
                                    {!selectedFiles["diplome4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["diplome4"] ?  
                            <>
                            {!InputVisible.diplome5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un diplome" name='diplome5' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome5' onChange={(e) => handleFileChange(e,"diplome5")} />
                                    {!selectedFiles["diplome5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["diplome5"] ?  
                            <>
                            {!InputVisible.diplome6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un diplome" name='diplome6' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='diplome6' onChange={(e) => handleFileChange(e,"diplome6")} />
                                    {!selectedFiles["diplome6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                    {dataForm.type_poste === 'PER' ? 
                    <>
                        <InputF  required={true}  className="rounded-left mb-2" label="Lettre de recommendation 1" message={<span style={{color:'red'}}>*</span>} type='file' name='recommandation1' onChange={(e) => handleFileChange(e,"recommandation1")} />
                        {!selectedFiles["recommandation1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                        <InputF  required={true}  className="rounded-left mb-2" label="Lettre de recommendation 2" message={<span style={{color:'red'}}>*</span>} type='file' name='recommandation2' onChange={(e) => handleFileChange(e,"recommandation2")} />
                        {!selectedFiles["recommandation2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                        
                            <InputF  required={true}  className="rounded-left mb-2" label="Résumé de la Thèse ou du Master" type='file' message={<span style={{color:'red'}}>*</span>} name='resume_these' onChange={(e) => handleFileChange(e,"resume_these")} />
                        {!selectedFiles["resume_these"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                        <InputF required={true} className="rounded-left mb-2" label="Les justificatifs de l’expérience dans l’enseignement (attestations des services faits)" message={<span style={{color:'red'}}>*</span>} type='file' name='justificatif_enseignement' onChange={(e) => handleFileChange(e,"justificatif_enseignement")} />
                    {!selectedFiles["justificatif_enseignement"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                    {/* autres jutificatif emseignement */}
                    {gestionfichier["justificatif_enseignement"] ?  
                                <>
                                {!InputVisible.justificatif6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif6' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif6' onChange={(e) => handleFileChange(e,"justificatif6")} />
                                        {!selectedFiles["justificatif6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    {gestionfichier["justificatif6"] ?  
                                <>
                                {!InputVisible.justificatif7   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif7' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif7' onChange={(e) => handleFileChange(e,"justificatif7")} />
                                        {!selectedFiles["justificatif7"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    {gestionfichier["justificatif7"] ?  
                                <>
                                {!InputVisible.justificatif8   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='justificatif8' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif8' onChange={(e) => handleFileChange(e,"justificatif8")} />
                                        {!selectedFiles["justificatif8"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                        <InputF className="rounded-left mb-2" label="Publications scientifiques" required={true}  type='file' name='publication_scientifique' onChange={(e) => handleFileChange(e,"publication_scientifique")} />
                        {!selectedFiles["publication_scientifique"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                        
                        {/* Gestion d'ajout de nouveau champs */}
                        <div className='autres_publications' >
                        {gestionfichier["publication_scientifique"] ?  
                                <>
                                {!InputVisible.publication2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication2'  />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication2' onChange={(e) => handleFileChange(e,"publication2")} />
                                        {!selectedFiles["publication2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {/* Fin de Gestion d'ajout de nouveau champs */}
                        {gestionfichier["publication2"] ?  
                                <>
                                {!InputVisible.publication3    ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication3' onChange={(e) => handleFileChange(e,"publication3")} />
                                        {!selectedFiles["publication3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {gestionfichier["publication3"] ?  
                                <>
                                {!InputVisible.publication4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='publication4' onChange={(e) => handleFileChange(e,"publication4")} />
                                        {!selectedFiles["publication4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                        }
                        {gestionfichier["publication4"] ?  
                            <>
                            {!InputVisible.publication5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication5' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication5' onChange={(e) => handleFileChange(e,"publication5")} />
                                    {!selectedFiles["publication5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication5"] ?  
                            <>
                            {!InputVisible.publication6   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication6' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication6' onChange={(e) => handleFileChange(e,"publication6")} />
                                    {!selectedFiles["publication6"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication6"] ?  
                            <>
                            {!InputVisible.publication7   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication7' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication7' onChange={(e) => handleFileChange(e,"publication7")} />
                                    {!selectedFiles["publication7"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication7"] ?  
                            <>
                            {!InputVisible.publication8   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication8' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication8' onChange={(e) => handleFileChange(e,"publication8")} />
                                    {!selectedFiles["publication8"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {gestionfichier["publication8"] ?  
                            <>
                            {!InputVisible.publication9   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication9' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication9' onChange={(e) => handleFileChange(e,"publication9")} />
                                    {!selectedFiles["publication9"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        }
                        {/* {gestionfichier["publication9"] ?  
                            <>
                            {!InputVisible.publication10   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='publication10' />  :
                                <>
                                    <InputF className="rounded-left mb-2" label="" type='file' name='publication10' onChange={(e) => handleFileChange(e,"publication10")} />
                                    {!selectedFiles["publication10"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                </> 
                            }
                            </>
                            : null
                        } */}
                        </div>
                        {/* <InputF  className="rounded-left mb-2" label="Communications"  type='file' name='communication' onChange={(e) => handleFileChange(e,"communication")} />
                        {!selectedFiles["communication"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                            {gestionfichier["communication"]?  
                                <>
                                {!InputVisible.communication2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication2' onChange={(e) => handleFileChange(e,"communication2")} />
                                        {!selectedFiles["communication2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication2"] ?  
                                <>
                                {!InputVisible.communication3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication3' onChange={(e) => handleFileChange(e,"communication3")} />
                                        {!selectedFiles["communication3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication3"] ?  
                                <>
                                {!InputVisible.communication4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication4' onChange={(e) => handleFileChange(e,"communication4")} />
                                        {!selectedFiles["communication4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                            {gestionfichier["communication4"] ?  
                                <>
                                {!InputVisible.communication5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} name='communication5' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='communication5' onChange={(e) => handleFileChange(e,"communication5")} />
                                        {!selectedFiles["communication5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            } */}
                    </>: null }
                    <InputF required={false} className="rounded-left mb-2" label="Les attestations de travail justifiant l'expérience dans le domaine" message={<span style={{color:'red'}}>*</span>} type='file' name='justificatif_enseignement' onChange={(e) => handleFileChange(e,"justificatif_enseignement")} />
                    {!selectedFiles["justificatif_enseignement"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                    <InputF className="rounded-left mb-2" label="Autres éléments de preuve pouvant justifier le CV" type='file' name='justificatif1' onChange={(e) => handleFileChange(e,"justificatif1")} />  
                    {!selectedFiles["justificatif1"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                    {gestionfichier["justificatif1"] ?  
                                <>
                                {!InputVisible.justificatif2   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un justificatif" name='justificatif2' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif2' onChange={(e) => handleFileChange(e,"justificatif2")} />
                                        {!selectedFiles["justificatif2"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    {gestionfichier["justificatif2"] ?  
                                <>
                                {!InputVisible.justificatif3   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un justificatif" name='justificatif3' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif3' onChange={(e) => handleFileChange(e,"justificatif3")} />
                                        {!selectedFiles["justificatif3"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    {gestionfichier["justificatif3"] ?  
                                <>
                                {!InputVisible.justificatif4   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un justificatif" name='justificatif4' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif4' onChange={(e) => handleFileChange(e,"justificatif4")} />
                                        {!selectedFiles["justificatif4"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    {gestionfichier["justificatif4"] ?  
                                <>
                                {!InputVisible.justificatif5   ? <IconForFile toggleInputVisibility={toggleInputVisibility} label="Ajouter un justificatif" name='justificatif5' />  :
                                    <>
                                        <InputF className="rounded-left mb-2" label="" type='file' name='justificatif5' onChange={(e) => handleFileChange(e,"justificatif5")} />
                                        {!selectedFiles["justificatif5"]? <span style={{color:'red'}}>taille du fichier {'>'} 2 Mo veuillez le réduire . </span>: null}
                                    </> 
                                }
                                </>
                                : null
                            }
                    
                    {complete}
                </div>
                )}
           </div>
           {errors ? <><div className="alert alert-danger" role="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" fill="currentColor" className="bi bi-exclamation-triangle" viewBox="0 0 16 16">
                                <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.146.146 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.163.163 0 0 1-.054.06.116.116 0 0 1-.066.017H1.146a.115.115 0 0 1-.066-.017.163.163 0 0 1-.054-.06.176.176 0 0 1 .002-.183L7.884 2.073a.147.147 0 0 1 .054-.057zm1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566z"/>
                                <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0zM7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995z"/>
                                </svg> Veuillez remplir tous les champs
                            </div></> : null}
           <div className="buttons">
            {step > 1 && (
                <Button variant='primary' className='float-start mb-2' size="md" onClick={handlePreviousStep}>Précedent</Button>
            )}
            {step < 3 && (
                <Button className='float-end mb-2' variant='primary' size="md" onClick={handleNextStep}>Suivant</Button>
            )}
            {step === 3 && 
                <Button  variant="primary" type='submit' size="md"
                // disabled={!ok}
                    className="p-2 float-end mb-2">
                    Valider  {submitted ?
                        <Spinner animation="grow"
                        size="sm" role="status"
                        >
                        <span className="visually-hidden">Loading...</span>
                        </Spinner>
                        : null}
                </Button>
            }
            </div>
          </Form>
        </div>
        </div>
      </div>
    </>
  )
}
export default RecrutementPer;